import { ApiAbstract } from '../abstract';
import { IExceptionWord, ExceptionWordDto } from '../../../types/exceptionWord';

export class ApiExceptionWordConfiguration extends ApiAbstract<
  IExceptionWord,
  ExceptionWordDto
> {}
